<template>
  <span :class="`status ${statusObj.color} ${props.outlined ? 'status-outlined' : ''}`" data-testid="status-indicator">
    {{ statusObj.name }}
  </span>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import type { Order } from '@/types/types';
import translator from '@/locale/translator';

const props = defineProps<{ status?: Order['lead_order_status'] | 'draft'; outlined?: boolean }>();
const statusObj = computed(() => {
  const defaultStatus = { name: translator.get(`order.status.${props.status}`), color: 'status-red', animated: true };
  switch (props.status) {
    case 'draft':
      return { ...defaultStatus, color: 'status-green' };
    case 'to_be_confirmed':
      return { ...defaultStatus, color: 'status-yellow' };
    case 'confirmed':
      return { ...defaultStatus, color: 'status-purple' };
    case 'running':
      return { ...defaultStatus, color: 'status-green' };
    case 'waiting_to_finish':
      return { ...defaultStatus, color: 'status-orange' };
    case 'finished':
      return { ...defaultStatus, color: 'status-blue', animated: false };
    default:
      return { ...defaultStatus, name: 'Error' };
  }
});
</script>
<style scoped>
.status {
  text-wrap: nowrap;
}

.status-outlined {
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
}
.status-green {
  border: 1px solid #abefc6;
  background: #ecfdf3;
  color: #067647;
}
</style>
